// extracted by mini-css-extract-plugin
export default {"shareContainer":"Share_shareContainer__lV0HQ","shareLinkWrapper":"Share_shareLinkWrapper__nTTlU"};